<template>
  <div :class="$style.footer">
    <div :class="$style.footerInner">
      <a
        href="https://extranetdev.cm-pombal.pt/"
        target=""
        rel="noopener noreferrer"
        :class="$style.logo"
      >
        <img src="/logo.png" alt="" height="20" width="20" style="margin-right: 5px;" />

        <strong class="mr-2">{{ settings.logo }}</strong>
      </a>
      <br />
      <p class="mb-0">
        <a href="https://www.cm-pombal.pt/" target="_blank" rel="noopener noreferrer">
          Município de pombal
        </a>
        |
        {{ new Date().getFullYear() }}
      </p>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
export default {
  setup() {
    const store = useStore()
    const settings = computed(() => store.getters.settings)

    return {
      settings,
    }
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
